var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbnail3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 328,
    height: 225,
    viewBox: "0 0 328 225",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M328 0H0V225H328V0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1078 8.50928H8.60645V13.2362H85.1078V8.50928Z",
    fill: "#E0E0E0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M319.393 8.50928H89.8887V13.2362H319.393V8.50928Z",
    fill: "#E0E0E0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M82.2391 29.9668H8.60645V49.0742H82.2391V29.9668Z",
    stroke: "#CCCCCC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M82.2391 104.578H8.60645V123.685H82.2391V104.578Z",
    stroke: "#CCCCCC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M82.2391 86.3784H8.60645V104.576H82.2391V86.3784Z",
    stroke: "#CCCCCC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M82.2391 160.988H8.60645V179.185H82.2391V160.988Z",
    stroke: "#CCCCCC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M82.2391 198.293H8.60645V216.492H82.2391V198.293Z",
    stroke: "#CCCCCC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M82.2391 49.0752H8.60645V67.2726H82.2391V49.0752Z",
    stroke: "#CCCCCC"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M82.2391 123.684H8.60645V141.881H82.2391V123.684Z",
    stroke: "#CCCCCC"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M82.2391 67.2705H8.60645V86.3779H82.2391V67.2705Z",
    stroke: "#CCCCCC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M82.2391 141.884H8.60645V160.991H82.2391V141.884Z",
    stroke: "#CCCCCC"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M82.2391 179.185H8.60645V198.293H82.2391V179.185Z",
    stroke: "#CCCCCC"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M109.971 29.9668H82.2393V49.0742H109.971V29.9668Z",
    stroke: "#CCCCCC"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M109.971 104.578H82.2393V123.685H109.971V104.578Z",
    stroke: "#CCCCCC"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M109.971 86.3784H82.2393V104.576H109.971V86.3784Z",
    stroke: "#CCCCCC"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M109.971 160.988H82.2393V179.185H109.971V160.988Z",
    stroke: "#CCCCCC"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M109.971 198.293H82.2393V216.492H109.971V198.293Z",
    stroke: "#CCCCCC"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M109.971 49.0752H82.2393V67.2726H109.971V49.0752Z",
    stroke: "#CCCCCC"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M109.971 123.684H82.2393V141.881H109.971V123.684Z",
    stroke: "#CCCCCC"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M109.971 67.2705H82.2393V86.3779H109.971V67.2705Z",
    stroke: "#CCCCCC"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M109.971 141.884H82.2393V160.991H109.971V141.884Z",
    stroke: "#CCCCCC"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M109.971 179.185H82.2393V198.293H109.971V179.185Z",
    stroke: "#CCCCCC"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M149.178 29.9668H109.971V49.0742H149.178V29.9668Z",
    stroke: "#CCCCCC"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M149.178 104.578H109.971V123.685H149.178V104.578Z",
    stroke: "#CCCCCC"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M149.178 86.3784H109.971V104.576H149.178V86.3784Z",
    stroke: "#CCCCCC"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M149.178 160.988H109.971V179.185H149.178V160.988Z",
    stroke: "#CCCCCC"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M149.178 198.293H109.971V216.492H149.178V198.293Z",
    stroke: "#CCCCCC"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M149.178 49.0752H109.971V67.2726H149.178V49.0752Z",
    stroke: "#CCCCCC"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M149.178 123.684H109.971V141.881H149.178V123.684Z",
    stroke: "#CCCCCC"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M149.178 67.2705H109.971V86.3779H149.178V67.2705Z",
    stroke: "#CCCCCC"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M149.178 141.884H109.971V160.991H149.178V141.884Z",
    stroke: "#CCCCCC"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M149.178 179.185H109.971V198.293H149.178V179.185Z",
    stroke: "#CCCCCC"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M82.2391 22.6899H8.60645V29.969H82.2391V22.6899Z",
    fill: "#EEEEEE",
    stroke: "#CCCCCC"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M109.971 22.6899H82.2393V29.969H109.971V22.6899Z",
    fill: "#EEEEEE",
    stroke: "#CCCCCC"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M149.178 22.6899H109.971V29.969H149.178V22.6899Z",
    fill: "#EEEEEE",
    stroke: "#CCCCCC"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M319.393 29.9668H291.661V49.0742H319.393V29.9668Z",
    stroke: "#CCCCCC"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M319.393 104.578H291.661V123.685H319.393V104.578Z",
    stroke: "#CCCCCC"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M319.393 86.3784H291.661V104.576H319.393V86.3784Z",
    stroke: "#CCCCCC"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M319.393 160.988H291.661V179.185H319.393V160.988Z",
    stroke: "#CCCCCC"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M319.393 198.293H291.661V216.492H319.393V198.293Z",
    stroke: "#CCCCCC"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M319.393 49.0752H291.661V67.2726H319.393V49.0752Z",
    stroke: "#CCCCCC"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M319.393 123.684H291.661V141.881H319.393V123.684Z",
    stroke: "#CCCCCC"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M319.393 67.2705H291.661V86.3779H319.393V67.2705Z",
    stroke: "#CCCCCC"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M319.393 141.884H291.661V160.991H319.393V141.884Z",
    stroke: "#CCCCCC"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M319.393 179.185H291.661V198.293H319.393V179.185Z",
    stroke: "#CCCCCC"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M291.662 29.9668H263.93V49.0742H291.662V29.9668Z",
    stroke: "#CCCCCC"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M291.662 104.578H263.93V123.685H291.662V104.578Z",
    stroke: "#CCCCCC"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M291.662 86.3784H263.93V104.576H291.662V86.3784Z",
    stroke: "#CCCCCC"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M291.662 160.988H263.93V179.185H291.662V160.988Z",
    stroke: "#CCCCCC"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M291.662 198.293H263.93V216.492H291.662V198.293Z",
    stroke: "#CCCCCC"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M291.662 49.0752H263.93V67.2726H291.662V49.0752Z",
    stroke: "#CCCCCC"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M291.662 123.684H263.93V141.881H291.662V123.684Z",
    stroke: "#CCCCCC"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M291.662 67.2705H263.93V86.3779H291.662V67.2705Z",
    stroke: "#CCCCCC"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M291.662 141.884H263.93V160.991H291.662V141.884Z",
    stroke: "#CCCCCC"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M291.662 179.185H263.93V198.293H291.662V179.185Z",
    stroke: "#CCCCCC"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M263.929 29.9668H236.198V49.0742H263.929V29.9668Z",
    stroke: "#CCCCCC"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M263.929 104.578H236.198V123.685H263.929V104.578Z",
    stroke: "#CCCCCC"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M263.929 86.3784H236.198V104.576H263.929V86.3784Z",
    stroke: "#CCCCCC"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M263.929 160.988H236.198V179.185H263.929V160.988Z",
    stroke: "#CCCCCC"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M263.929 198.293H236.198V216.492H263.929V198.293Z",
    stroke: "#CCCCCC"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M263.929 49.0752H236.198V67.2726H263.929V49.0752Z",
    stroke: "#CCCCCC"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M263.929 123.684H236.198V141.881H263.929V123.684Z",
    stroke: "#CCCCCC"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M263.929 67.2705H236.198V86.3779H263.929V67.2705Z",
    stroke: "#CCCCCC"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M263.929 141.884H236.198V160.991H263.929V141.884Z",
    stroke: "#CCCCCC"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M263.929 179.185H236.198V198.293H263.929V179.185Z",
    stroke: "#CCCCCC"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M176.91 29.9668H149.178V49.0742H176.91V29.9668Z",
    stroke: "#CCCCCC"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M176.91 104.578H149.178V123.685H176.91V104.578Z",
    stroke: "#CCCCCC"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M176.91 86.3784H149.178V104.576H176.91V86.3784Z",
    stroke: "#CCCCCC"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M176.91 160.988H149.178V179.185H176.91V160.988Z",
    stroke: "#CCCCCC"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M176.91 198.293H149.178V216.492H176.91V198.293Z",
    stroke: "#CCCCCC"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M176.91 49.0752H149.178V67.2726H176.91V49.0752Z",
    stroke: "#CCCCCC"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M176.91 123.684H149.178V141.881H176.91V123.684Z",
    stroke: "#CCCCCC"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M176.91 67.2705H149.178V86.3779H176.91V67.2705Z",
    stroke: "#CCCCCC"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M176.91 141.884H149.178V160.991H176.91V141.884Z",
    stroke: "#CCCCCC"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M176.91 179.185H149.178V198.293H176.91V179.185Z",
    stroke: "#CCCCCC"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M236.198 29.9668H176.909V49.0742H236.198V29.9668Z",
    stroke: "#CCCCCC"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M236.198 104.578H176.909V123.685H236.198V104.578Z",
    stroke: "#CCCCCC"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M236.198 86.3784H176.909V104.576H236.198V86.3784Z",
    stroke: "#CCCCCC"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M236.198 160.988H176.909V179.185H236.198V160.988Z",
    stroke: "#CCCCCC"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M236.198 198.293H176.909V216.492H236.198V198.293Z",
    stroke: "#CCCCCC"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M236.198 49.0752H176.909V67.2726H236.198V49.0752Z",
    stroke: "#CCCCCC"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M236.198 123.684H176.909V141.881H236.198V123.684Z",
    stroke: "#CCCCCC"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M236.198 67.2705H176.909V86.3779H236.198V67.2705Z",
    stroke: "#CCCCCC"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M236.198 141.884H176.909V160.991H236.198V141.884Z",
    stroke: "#CCCCCC"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M236.198 179.185H176.909V198.293H236.198V179.185Z",
    stroke: "#CCCCCC"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M319.393 22.6899H291.661V29.969H319.393V22.6899Z",
    fill: "#EEEEEE",
    stroke: "#CCCCCC"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M291.662 22.6899H263.93V29.969H291.662V22.6899Z",
    fill: "#EEEEEE",
    stroke: "#CCCCCC"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M263.929 22.6899H236.198V29.969H263.929V22.6899Z",
    fill: "#EEEEEE",
    stroke: "#CCCCCC"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M176.91 22.6899H149.178V29.969H176.91V22.6899Z",
    fill: "#EEEEEE",
    stroke: "#CCCCCC"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M236.198 22.6899H176.909V29.969H236.198V22.6899Z",
    fill: "#EEEEEE",
    stroke: "#CCCCCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbnail3);
export default __webpack_public_path__ + "static/media/thumbnail-3.1c29b02c89531073525b84a4a3db7c07.svg";
export { ForwardRef as ReactComponent };